import Store from '@/store/index'

export const ButtonShow = (value) => {
  const buttonShow = !!Store.state.buttonList.find((item) => value === item.butCode)
  return buttonShow
}
